import { render, staticRenderFns } from "./FloatingCenterSpinner.vue?vue&type=template&id=460543e2&scoped=true&"
import script from "./FloatingCenterSpinner.vue?vue&type=script&lang=js&"
export * from "./FloatingCenterSpinner.vue?vue&type=script&lang=js&"
import style0 from "./FloatingCenterSpinner.vue?vue&type=style&index=0&id=460543e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460543e2",
  null
  
)

export default component.exports